// For /user-panel/orders/orders
export default [
    {
        key: 'status',
        label: 'Status',
        variant: 'column-md'
    },
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/ordersConfirm.js